import {
    monthsProduct,
    validationDefaultNew,
    validationDefault,
    defaultYearReport,
    defaultMonthReport,
    maxModeloVehiculo,
} from '../../components/utilities/rulesUtilities';

import genericOptions from '../defaultConfigRole/genericOptions';
import genericColumnsCalculator from '../defaultConfigRole/genericColumnsCalculator';
import requestsListStatus from './requestsListStatus';
import requestsWarrantyList from './requestsWarrantyList';
import { randomFloat } from '../../components/utilities/functions/General';
import { objGenericUrl } from '../defaultConfigRole/genericUrls';
import { PROPERTIES, URL } from '../../constants/constantValues';
import requestsFinancialSolutionsStatus from './requestsFinancialSolutionsStatus';

const Rules = {
    role_1b0c9c74690d413cbdd3ac8b25bf2284: {
        home: 'credits',
        requestsListStatus,
        requestsWarrantyList,
        requestsFinancialSolutionsStatus,
        views: {
            create: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: [
                    'listRequestCredit',
                    'viewGestionGroup',
                    'viewWarrantyCount',
                ],
                components: [
                    {
                        name: 'Solicitante',
                        component: ['InformationClient', 'FilterAutomatics'],
                    },
                    {
                        name: 'Contacto',
                        component: ['ContactsClient'],
                    },
                    {
                        name: 'Cónyuge',
                        component: ['ConyugeClient'],
                    },
                    {
                        name: 'Negocio',
                        component: ['BusinessInformationCredit'],
                    },
                    { name: 'Referencias', component: ['ReferencesCredit'] },
                    { name: 'Codeudores', component: ['CodebtorCredit'] },
                    {
                        name: 'Microempresa',
                        component: ['AnalisisCredit'],
                    },
                    { name: 'Ppi', component: ['PpiCredit'] },
                    { name: 'Documentos', component: ['DocumentsCredit'] },
                    {
                        name: 'Comite',
                        component: ['ApprovalCertificate'],
                    },
                ],
                actionStatus: ['modalAssignUser', 'modalResumeRequest'],
                actionStatusAll: ['resumen', 'anotaciones'],
                notEditForm: true,
                groupUser: 31,
            },
            createWarranty: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: [
                    'listRequestCredit',
                    'viewGestionGroup',
                    'viewWarrantyCount',
                ],
                components: [
                    {
                        name: 'Cliente',
                        component: [
                            // 'InformationClient',
                            // 'ContactsClient',
                            // 'BusinessInformationCreditAlly',
                            'ClientCardsInfo',
                            'AutomaticFilters',
                        ],
                    },
                    {
                        name: 'Información del crédito',
                        component: ['FinancialState'],
                    },
                    { name: 'Documentos', component: ['DocumentsWarranty'] },
                    {
                        name: 'Inf. del Vehículo',
                        component: [
                            'InformationWarrantyVehicle',
                            'ContactsWarranty',
                        ],
                    },
                    {
                        name: 'Inf. garantía vehicular',
                        component: [
                            // 'InformationWarranty',
                            'BillsWarranty',
                            'FinancialEvaluationWarranty',
                        ],
                    },
                ],
                actionStatus: [],
                actionStatusAll: ['resumen', 'anotaciones'],
                notEditForm: true,
            },
            createFinancialSolutions: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: [
                    'listRequestCredit',
                    'viewFSGroup',
                    'viewWarrantyCount',
                ],
                components: [
                    {
                        name: 'Información del crédito',
                        component: ['FinancialState'],
                    },
                    {
                        name: 'Solución financiera',
                        component: ['FinancialSolutions'],
                    },
                    {
                        name: 'Documentos',
                        component: ['DocumentsFinancialSolution'],
                    },
                ],
                actionStatus: [
                    'desistir',
                    'rechazar',
                    'devolver',
                    'anotaciones',
                    'retornar',
                ],
                actionStatusAll: ['anotaciones'],
                notEditForm: true,
            },
            consult: {
                permisions: ['consultClientList', 'ConsultClientEdit'],
                components: [
                    {
                        name: 'Solicitante',
                        component: ['InformationClient'],
                    },
                    { name: 'Contacto', component: ['ContactsClient'] },
                    { name: 'Documentos', component: ['DocumentsClient'] },
                    {
                        name: 'Solicitudes cliente',
                        component: ['RequestsClient'],
                    },
                    { name: 'Crédito', component: ['GygClient'] },
                ],
                noShowFieldsConsult: true,
            },
            profile: {
                fields: [
                    {
                        name: 'identification_number',
                        label: 'Número de identificación',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificación'
                        ),
                    },
                    {
                        name: 'first_name',
                        label: 'Nombres',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'nombres'
                        ),
                    },
                    {
                        name: 'last_name',
                        label: 'Apellidos',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'apellidos'
                        ),
                    },
                    {
                        name: 'phone_number',
                        label: 'Número telefónico',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                ],
            },
        },
        components: {
            informationClient: {
                permisions: ['informationClient:list'],
                automaticFilters: true,
                isFinancialSolution: true,
                fields: [
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                    },
                    {
                        label: 'Número de identificación',
                        name: 'numero_identificacion',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                    },
                    {
                        name: 'primer_nombre',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'primer_apellido',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'genero',
                        label: 'Género',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        label: 'Lugar expedición documento',
                        disabled: true,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        label: 'Fecha expedición documento',
                        disabled: true,
                        type: 'date',
                        col: 3,
                    },
                    {
                        name: 'lugar_nacimiento',
                        disabled: true,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'fecha_nacimiento',
                        disabled: true,
                        type: 'date',
                        col: 3,
                    },
                    {
                        name: 'grupo_social',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.grupo_etnico,
                    },
                ],
            },
            socioeconomicClient: {
                permisions: [
                    'socioeconomicClient:list',
                    'socioeconomicClient:edit',
                ],
                fields: [
                    {
                        name: 'estado_civil',
                        disabled: true,
                        type: 'select',
                        col: 2,
                        options: genericOptions.estado_civil,
                    },
                    {
                        name: 'tipo_vivienda',
                        disabled: true,
                        type: 'select',
                        col: 2,
                        options: genericOptions.tipo_vivienda,
                        defaultValue: [],
                    },
                    {
                        name: 'estrato',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                    },
                    {
                        name: 'ciiu',
                        label: 'Actividad económica',
                        disabled: true,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                    },
                    {
                        name: 'descripcion_actividad_economica',
                        label: 'Descripción actividad económica',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        label: 'Antigüedad residencia (meses)',
                        name: 'antiguedad_residencia',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                    },
                    {
                        name: 'tamano_hogar',
                        label: 'Integrantes del hogar',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                    },
                    {
                        name: 'personas_a_cargo',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                    },
                    {
                        name: 'numero_hijos',
                        label: 'Número hijos',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                    },
                    {
                        name: 'escolaridad',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.escolaridad,
                    },
                    {
                        name: 'naturaleza',
                        disabled: true,
                        type: 'hidden',
                        col: 3,
                        // validation: validationDefault(
                        //     ['required'],
                        //     'naturaleza'
                        // ),
                        options: [
                            {
                                value: 'I',
                                label: 'Independiente',
                                fields: [
                                    {
                                        name: 'tipo_de_negocio',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE.required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE
                                                        .minLength,
                                                },
                                            ],
                                            'tipo de negocio'
                                        ),
                                    },
                                    {
                                        name: 'nombre_negocio',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .minLength,
                                                },
                                            ],
                                            'nombre negocio'
                                        ),
                                    },
                                    {
                                        name: 'experiencia',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .minLength,
                                                },
                                            ],
                                            'experiencia'
                                        ),
                                    },
                                    {
                                        name: 'antiguedad',
                                        label: 'Antigüedad',
                                        disabled: false,
                                        type: 'integer',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES.ANTIQUITY
                                                        .max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES.ANTIQUITY
                                                        .min,
                                                },
                                            ],
                                            'antigüedad'
                                        ),
                                    },
                                    {
                                        name: 'actividad',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.ACTIVITY
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.ACTIVITY
                                                        .minLength,
                                                },
                                            ],
                                            'actividad'
                                        ),
                                    },
                                    {
                                        label: 'descripción',
                                        name: 'descripcion',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .DESCRIPTION.minLength,
                                                },
                                            ],
                                            'descripción'
                                        ),
                                    },
                                    {
                                        name: 'ingresos_aproximados',
                                        disabled: false,
                                        type: 'integer',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [{ type: 'required', value: true }],
                                            'segundo apellido'
                                        ),
                                    },
                                    {
                                        name: 'sector_economico',
                                        label: 'Sector económico',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .ECONOMIC_SECTOR
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .ECONOMIC_SECTOR
                                                        .minLength,
                                                },
                                            ],
                                            'sector económico'
                                        ),
                                    },
                                    {
                                        name: 'empleados_permanentes',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES
                                                        .required,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES.max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES.min,
                                                },
                                            ],
                                            'empleados permanentes'
                                        ),
                                    },
                                    {
                                        name: 'empleados_temporales',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES
                                                        .required,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES.max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES.min,
                                                },
                                            ],
                                            'empleados temporales'
                                        ),
                                    },
                                    {
                                        name: 'tipo_local',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [{ type: 'required', value: true }],
                                            'tipo de local'
                                        ),
                                    },
                                ],
                            },
                        ],
                        isMulti: false,
                    },
                ],
            },
            contactsClient: {
                permisions: ['contactsClient:list', 'contactsClient:edit'],
                tittle: 'solicitante',
                fields: [
                    {
                        name: 'ciudad_contacto',
                        label: 'Ciudad',
                        disabled: true,
                        type: 'autocomplete',
                        col: 6,
                        showTable: true,
                        options: [],
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'barrio',
                        disabled: true,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'direccion',
                        label: 'Dirección',
                        disabled: true,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: true,
                        type: 'string',
                        col: 4,
                        showTable: true,
                    },
                    {
                        name: 'telefono',
                        label: 'Teléfono',
                        disabled: true,
                        type: 'phone',
                        col: 4,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],
                            'teléfono'
                        ),
                    },
                    {
                        name: 'celular',
                        label: 'Celular',
                        disabled: true,
                        type: 'celular',
                        col: 4,
                        showTable: true,
                    },
                    {
                        name: 'correo_electronico',
                        label: 'Correo electrónico',
                        disabled: true,
                        type: 'email',
                        col: 4,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.EMAIL.regExp,
                                    mesagge:
                                        'El correo electrónico ingresado no es válido',
                                },
                            ],
                            'correo electrónico'
                        ),
                    },
                    {
                        name: 'principal',
                        label: 'Principal',
                        disabled: true,
                        type: 'select',
                        options: genericOptions.direccion_principal,
                        defaultValue: [],
                        col: 4,
                        showTable: true,
                    },
                ],
                defaultValues: {
                    direccion: 'carrera 1 calle 1 # 1',
                    barrio: 'Ciudad modelo',
                    latitud: '11111324',
                    longitud: '38947239',
                    telefono: '',
                    celular: '',
                    correo_electronico: 'test@finamiga.co',
                    referencia_ubicacion: 'cerca a... diagonal a...',
                    tipo_ubicacion: 1,
                    departamento: 5,
                    ciudad_contacto: 1205,
                },
            },
            informationCredit: {
                permisions: [
                    'informationCredit:list',
                    'informationCredit:onlyRead',
                ],
                fields: [
                    {
                        name: 'subproducto',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                    },
                    {
                        name: 'oficina',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'ejecutivo',
                        url: URL.OFICINAS.value,
                    },
                    {
                        name: 'ejecutivo',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        dependency: 'oficinas',
                        url: URL.EJECUTIVOS.value,
                        notSearchGlobals: true,
                    },
                    {
                        name: 'origen',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        url: URL.ORIGEN.value,
                    },
                    {
                        name: 'medio',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        url: URL.MEDIO.value,
                    },
                    {
                        name: 'tipo_credito',
                        label: 'Tipo crédito',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_credito,
                    },
                    {
                        name: 'seguro_voluntario',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                    },
                    {
                        name: 'seguro_protegidos',
                        label: 'Seguro PROTEGI2',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        url: URL.SEGURO_FAMILIA.value,
                        dependency: 'subproducto',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: true,
                    //     type: 'select',
                    //     col: 3,
                    //     options: genericOptions.tipo_seguro_sbs,
                    // },
                ],
                fieldsFng: [
                    {
                        name: 'fng_producto',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        url: URL.FNG_PRODUCTO.value,
                        parentDependency: true,
                        childrenDependency: 'fng_porcentaje',
                    },
                    {
                        name: 'fng_porcentaje',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        dependency: 'fng_producto',
                        url: URL.FNG_PORCENTAJE.value, //?fng_producto=4',
                    },
                    {
                        name: 'fng_calificacion',
                        label: 'Fng calificación',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.calificacion,
                    },
                    {
                        name: 'fng_garantia',
                        label: 'Fng garantía',
                        disabled: true,
                        type: 'integer',
                        col: 4,
                    },
                ],
                fieldsDynamic: [],
                defaultValues: {
                    oficina: 9,
                    producto: 17,
                    origen: 1,
                    medio: 1,
                    tipo_credito: 1,
                    monto_solicitado: 5000000,
                    plazo_solicitado: 2,
                    cuota_inicial_solicitada: 1500000,
                    asesor: 'asesor test',
                    telefono_asesor: '123456798',
                    concesionario: 'concesionario test',
                    marca: 'Bajaj',
                    linea: 'Pulsar',
                    valor: 8000000,
                    soat: 480000,
                    impuestos: 120000,
                    matricula: 200000,
                    nombre_concesionario: 'concesionario test!',
                    tipo_motocicleta: 'motocicleta',
                },
            },
            productCredit: {
                permisions: ['productCredit:list', 'productCredit:edit'],
                fields: [],
                filedsConditional: {
                    p2: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p3: [
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 4,
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                    ],
                    p8: [
                        // Prestamiga Preferencial
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 4,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                    ],
                    p10: [
                        // Prestamiga Renovacion
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 4,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                    ],
                    p18: [
                        // Prestamiga Reactivacion
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 4,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                    ],
                    p6: [
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p12: [
                        // Cultiva renovacion
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p14: [
                        // Cultiva preferencial
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p17: [
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p40: [
                        // Vehiculos usados
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'modelo_vehiculo',
                            label: 'Modelo vehículo',
                            disabled: true,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: maxModeloVehiculo(),
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],
                                'modelo'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'valor_fasecolda',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p41: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p42: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p43: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p47: [
                        // Vehiculos renovacion
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/users/?groups=11&is_active=true',
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'Tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p113: [
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p114: [
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p115: [
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },

                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p117: [
                        // CARGA_ESPECIALES_2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p118: [
                        // carga pasajeros 2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },

                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p119: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p120: [
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 4,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                    ],
                    p131: [
                        // MOTO RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p132: [
                        // PROGRESA RECONSTRUYE
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 4,
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                    ],
                    p133: [
                        // CAMPO RECONSTRUYE
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p134: [
                        // CARGA RECONSTRUYE
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p135: [
                        // MOTOCARRO RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p136: [
                        // PROGRESA COMPROMISO VALLE RECONSTRUYE
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 4,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                    ],
                    p137: [
                        // CARGA 2.0 RECONSTRUYE
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p138: [
                        // CARGA ESPECIALES RECONSTRUYE
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p139: [
                        // CARGA PASAJEROS RECONSTRUYE
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },

                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },

                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p130: [
                        // MOTO COMPROMISO VALLE RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                        },
                        {
                            name: 'marca',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                        },
                        {
                            name: 'valor',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'soat',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'impuestos',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                        },
                        {
                            name: 'seguro_agro',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                },
            },
            documentsCredit: {
                permisions: ['documentsCredit:list', 'documentsCredit:edit'],
                disabledButtonSave: true,
                fields: [
                    {
                        name: 'tipo_documento',
                        disabled: true,
                        type: 'select',
                        col: 5,
                        options: genericOptions.tipo_de_adjunto,
                        showTable: true,
                    },
                    {
                        name: 'documento',
                        disabled: true,
                        type: 'file',
                        col: 5,
                    },
                ],
            },
            documentsFinancialSolution: {
                permisions: [
                    'documentsFinancialSolution:list',
                    'documentsFinancialSolution:edit',
                ],
                accept: 'image/png, image/jpeg, image/jpg, application/pdf',
                fields: [
                    {
                        name: 'sf_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: `/globals/sf_tipo_documentos/?roles=31&tipo_soluciones={0}`,
                        reduxParams: ['financialSolution.tipo_sf_id'],
                        shouldSendRequestConstantly: true,
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                    },
                ],
            },
            observationCredit: {
                permisions: [
                    'observationCredit:list',
                    'observationCredit:edit',
                ],
                fields: [
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: true,
                        type: 'string',
                        rows: 1,
                        typeColumn: 2,
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                    },
                ],
            },
            observationFinancialSolution: {
                permisions: [
                    'observationCredit:list',
                    'observationCredit:edit',
                ],
                fields: [
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'textarea',
                        col: 12,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            calculatorCredit: {
                permisions: [
                    'calculatorCredit:list',
                    'calculatorCredit:edit',
                    'calculatorCredit:simulator',
                ],
                summaryCredit: genericColumnsCalculator.summaryCredit,
                monthlyValues: genericColumnsCalculator.monthlyValues,
                defaultValues: {},
                fields: [
                    {
                        name: 'subproducto',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                    },
                    {
                        name: 'seguro_voluntario',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                    },
                    {
                        name: 'seguro_protegidos',
                        label: 'Seguro PROTEGI2',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        clear: true,
                        url: URL.SEGURO_FAMILIA.value,
                        dependency: 'subproducto',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: false,
                    //     type: 'select',
                    //     col: 4,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                ],
            },
            ReferencesCredit: {
                fields: [
                    {
                        name: 'persona_referenciada',
                        disabled: false,
                        type: 'select',
                        col: 12,
                        url: objGenericUrl.personaSolicitudReferecias,
                        reduxParams: ['client.id', 'credit.id'],
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'persona referenciada'
                        ),
                    },
                    {
                        name: 'celular',
                        disabled: false,
                        type: 'celular',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],
                            'celular'
                        ),
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],
                            'primer nombre'
                        ),
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'primer nombre'
                        ),
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],
                            'primer apellido'
                        ),
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo apellido'
                        ),
                    },
                    {
                        name: 'estado_referencia',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.estado_referencia,
                        validation: validationDefault(
                            ['required'],
                            'estado referencia'
                        ),
                    },
                    {
                        name: 'tipo_referencia',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        // options: genericOptions.tipo_referencia,
                        parentDependency: true,
                        childrenDependency: 'barrio_referencia',
                        url: '/globals/tipo_referencia/',
                        notSearchGlobals: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo referencia'
                        ),
                    },
                    {
                        name: 'parentesco_referencia',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        dependency: 'tipo_referencia',
                        url: '/globals/parentesco_referencia/',
                        // options: genericOptions.tipo_parentesco,
                        validation: validationDefault(
                            ['required'],
                            'parentesco'
                        ),
                    },
                    {
                        name: 'ciudad',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_referencia',
                        url: URL.CIUDADES.value,
                        validation: validationDefault(['required'], 'ciudad'),
                    },
                    {
                        name: 'barrio_referencia',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio referencia'
                        ),
                    },
                    {
                        name: 'direccion',
                        label: 'Dirección',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'dirección'
                        ),
                        showTable: true,
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.minLength,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.maxLength,
                                },
                            ],
                            'referencia ubicación'
                        ),
                    },
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.OBSERVATION.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.OBSERVATION.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.OBSERVATION.minLength,
                                },
                            ],
                            'observación'
                        ),
                    },
                ],
                fieldsKnowsHim: [
                    {
                        name: 'antiguedad',
                        label: '¿Hace cuanto tiempo lo conoce?',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: genericOptions.conoce_cliente,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad'
                        ),
                    },
                    {
                        name: 'recomendaria',
                        label: 'Recomendaría',
                        disabled: false,
                        type: 'switch',
                        col: 6,
                        typeColumn: 2,
                    },
                    {
                        name: 'actividad_economica',
                        label: 'Actividad económica',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .minLength,
                                },
                            ],
                            'actividad económica'
                        ),
                    },
                    {
                        name: 'antiguedad_actividad_economica',
                        label: 'Antigüedad actividad económica (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad actividad económica'
                        ),
                    },
                    {
                        name: 'actividad_economica_adicional',
                        label: 'Actividad económica adicional',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .minLength,
                                },
                            ],
                            'actividad económica adicional'
                        ),
                    },
                    {
                        name: 'antiguedad_actividad_economica_adicional',
                        label: 'Antigüedad actividad económica adicional (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad actividad económica adicional'
                        ),
                    },
                ],
                defaultValues: {
                    primer_nombre: 'pruebas1',
                    primer_apellido: 'sistemas',
                    segundo_apellido: 'sistemas 2',
                    celular: '3249872938',
                    direccion: 'carrera 1 calle 1 # 1',
                    barrio: 'Ciudad modelo',
                    estado_referencia: 1,
                    parentesco: 0,
                    tipo_referencia: 0,
                    conoce: true,
                    recomendaria: false,
                    actividad_economica: 'venta de pollos',
                    observacion: 'ninguna',
                    antiguedad: 2,
                },
            },
            analysisCredit: {
                permisions: ['analysisCredit:list'],
                fields: [
                    {
                        name: 'Liquidez del negocio',
                        desc: '',
                        fields: [
                            {
                                name: 'ventas',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                            {
                                name: 'costo_venta',
                                label: 'Costo venta (%)',
                                disabled: true,
                                type: 'percentage',
                                col: 6,
                            },
                            {
                                name: 'total_gastos',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'pagos_deudas',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'utilidad_neta',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                        ],
                    },
                    {
                        name: 'Liquidez familiar',
                        desc: '',
                        fields: [
                            {
                                name: 'otros_ingresos',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                            {
                                name: 'total_gastos_familiar',
                                label: 'Total gastos familiares',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                            {
                                name: 'liquidez_total',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                            {
                                name: 'capacidad_pago',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                        ],
                    },
                    {
                        name: 'Balance general de la microempresa',
                        desc: '',
                        fields: [
                            {
                                name: 'activos',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'pasivos',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'patrimonio',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                        ],
                    },
                    {
                        name: 'Indicadores financieros',
                        desc: '',
                        fields: [
                            {
                                name: 'capacidad_pago_porcentaje',
                                label: 'Capacidad pago porcentaje (%)',
                                disabled: true,
                                type: 'percentage',
                                col: 4,
                            },
                            {
                                name: 'capital_trabajo',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'endeudamiento_actual',
                                label: 'Endeudamiento actual (%)',
                                disabled: true,
                                type: 'percentage',
                                col: 4,
                            },
                            {
                                name: 'endeudamiento_futuro',
                                label: 'Endeudamiento futuro (%)',
                                disabled: true,
                                type: 'percentage',
                                col: 4,
                            },
                            {
                                name: 'rotacion',
                                label: 'Rotación de inventario (Días)',
                                disabled: true,
                                type: 'integer',
                                col: 4,
                            },
                            {
                                name: 'liquidez_financiera',
                                label: 'Liquidez razón corriente',
                                disabled: true,
                                type: 'integer',
                                col: 4,
                            },
                        ],
                    },
                    {
                        name: 'Propuesta',
                        desc: '',
                        fields: [
                            {
                                name: 'propuesta_economica',
                                label: 'Propuesta económica',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                            {
                                name: 'plazo_propuesta',
                                label: 'Plazo propuesto',
                                disabled: true,
                                type: 'select',
                                options: monthsProduct(17),
                                col: 6,
                            },
                            {
                                name: 'cuota_inicial_propuesta',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                            {
                                name: 'cuota_mensual_propuesta',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                        ],
                    },
                ],
                defaultValues: {
                    ventas: Math.floor(randomFloat(0, 1) * 1000000),
                    costo_venta: Math.floor(randomFloat(0, 1) * 10),
                    total_gastos: Math.floor(randomFloat(0, 1) * 10000),
                    pagos_deudas: 0,
                    utilidad_neta: 0,
                    otros_ingresos: 0,
                    total_gastos_familiar: Math.floor(
                        randomFloat(0, 1) * 10000
                    ),
                    liquidez_total: 0,
                    capacidad_pago: 0,
                    activos: Math.floor(randomFloat(0, 1) * 10000),
                    pasivos: Math.floor(randomFloat(0, 1) * 10000),
                    patrimonio: 0,
                    capacidad_pago_porcentaje: 0,
                    capital_trabajo: Math.floor(randomFloat(0, 1) * 10000),
                    endeudamiento_actual: 0,
                    endeudamiento_futuro: 0,
                    rotacion: Math.floor(randomFloat(0, 1) * 10000),
                    liquidez_financiera: 5,
                    propuesta_economica: Math.floor(
                        randomFloat(0, 1) * 1000000
                    ),
                    plazo_propuesta: Math.floor(randomFloat(0, 1) * 10),
                    cuota_inicial_propuesta: 0,
                    cuota_mensual_propuesta: Math.floor(
                        randomFloat(0, 1) * 10000
                    ),
                },
            },
            Ppi: {
                permission: ['Ppi:list' /**'Ppi:edit'**/],
                fields: [
                    {
                        id: '1',
                        question: '¿Cuántos miembros tiene el hogar?',
                        options: [
                            {
                                response: 'A. 2 o menos',
                                points: 20,
                                idQuestions: 'ppi_1_1',
                            },
                            {
                                response: 'B. 3 a 4',
                                points: 10,
                                idQuestions: 'ppi_1_2',
                            },
                            {
                                response: 'C. 5 a 6',
                                points: 3,
                                idQuestions: 'ppi_1_3',
                            },
                            {
                                response: 'D. 7 o más',
                                points: 0,
                                idQuestions: 'ppi_1_4',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_1',
                        disabled: true,
                    },
                    {
                        id: '2',
                        question:
                            '¿Todos los niños entre los 6 y 12 años actualmente asisten al preescolar o escuela?',
                        options: [
                            {
                                response:
                                    'A. Al menos un niño entre 6 y 12 años no asiste',
                                points: 0,
                                idQuestions: 'ppi_2_1',
                            },
                            {
                                response: 'B. No hay niños entre 6 y 12 años',
                                points: 7,
                                idQuestions: 'ppi_2_2',
                            },
                            {
                                response:
                                    'C. Todos los niños entre 6 y 12 años asisten',
                                points: 1,
                                idQuestions: 'ppi_2_3',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_2',
                        disabled: true,
                    },
                    {
                        id: '3',
                        question:
                            '¿Algún miembro de este hogar alcanzó un nivel educativo superior o universitario?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 6,
                                idQuestions: 'ppi_3_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_3_2',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_3',
                        disabled: true,
                    },
                    {
                        id: '4',
                        question:
                            '¿Algún miembro de este hogar tiene un trabajo con un contrato escrito?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 15,
                                idQuestions: 'ppi_4_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_4_2',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_4',
                        disabled: true,
                    },
                    {
                        id: '5',
                        question:
                            '¿Algún miembro de este hogar es un obrero o empleado de empresa particular/privada?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 9,
                                idQuestions: 'ppi_5_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_5_2',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_5',
                        disabled: true,
                    },
                    {
                        id: '6',
                        question:
                            '¿Algún miembro de este hogar es un patrón o empleador?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 15,
                                idQuestions: 'ppi_6_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_6_2',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_6',
                        disabled: true,
                    },
                    {
                        id: '7',
                        question:
                            '¿Este hogar tiene una máquina lavadora de ropa?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 6,
                                idQuestions: 'ppi_7_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_7_2',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_7',
                        disabled: true,
                    },
                    {
                        id: '8',
                        question: '¿Este hogar tiene un horno microondas?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 8,
                                idQuestions: 'ppi_8_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_8_2',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_8',
                        disabled: true,
                    },
                    {
                        id: '9',
                        question: '¿Este hogar tiene un carro particular?',
                        options: [
                            {
                                response: 'A. Sí',
                                points: 5,
                                idQuestions: 'ppi_9_1',
                            },
                            {
                                response: 'B. No',
                                points: 0,
                                idQuestions: 'ppi_9_2',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_9',
                        disabled: true,
                    },
                    {
                        id: '10',
                        question:
                            '¿Cuál es el material predominante de los pisos de la vivienda?',
                        options: [
                            {
                                response:
                                    'A. Tierra, arena, madera burda, tabla, tablón, otro vegetal',
                                points: 0,
                                idQuestions: 'ppi_10_1',
                            },
                            {
                                response: 'B. Cemento, gravilla',
                                points: 2,
                                idQuestions: 'ppi_10_2',
                            },
                            {
                                response:
                                    'C. Baldosín, ladrillo, vinisol, otros materiales sintéticos',
                                points: 9,
                                idQuestions: 'ppi_10_3',
                            },
                            {
                                response:
                                    'D. Mármol, madera pulida, alfombra o tapete de pared a pared',
                                points: 6,
                                idQuestions: 'ppi_10_4',
                            },
                        ],
                        type: 'radio',
                        name: 'ppi_10',
                        disabled: true,
                    },
                ],
            },
            BusinessInformationCredit: {
                permisions: [
                    'businessInformationCredit:list',
                    'businessInformationCredit:edit',
                ],
                fields: [
                    {
                        name: 'nombre',
                        label: 'Nombre del negocio',
                        disabled: true,
                        type: 'string',
                        col: 3,
                        showTable: true,
                    },
                    {
                        name: 'tipo_negocio',
                        label: 'Tipo de negocio',
                        disabled: true,
                        type: 'string',
                        col: 3,
                        showTable: true,
                    },
                    {
                        name: 'antiguedad',
                        label: 'Antigüedad de negocio (meses)',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        showTable: true,
                    },
                    {
                        name: 'antiguedad_local',
                        label: 'Antigüedad de negocio en local (meses)',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        showTable: true,
                    },
                    {
                        name: 'empleados_permanentes',
                        label: 'Empleados permanentes',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                    },
                    {
                        name: 'empleados_temporales',
                        label: 'Empleados temporales',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                    },
                    {
                        name: 'telefono',
                        label: 'Teléfono del negocio',
                        disabled: true,
                        type: 'phone',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],
                            'teléfono del negocio'
                        ),
                    },
                    {
                        name: 'celular',
                        label: 'Celular',
                        disabled: true,
                        type: 'celular',
                        col: 3,
                    },
                    {
                        name: 'sector_economico',
                        label: 'Sector económico del negocio',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.sector_economico,
                    },
                    {
                        name: 'negocio_ciiu',
                        label: 'Actividad del negocio',
                        disabled: true,
                        type: 'autocomplete',
                        col: 6,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                    },
                    {
                        name: 'descripcion_actividad',
                        label: 'Descripción de la actividad del negocio',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'ciudad_negocio',
                        label: 'Ciudad del negocio',
                        disabled: true,
                        type: 'autocomplete',
                        col: 6,
                        options: [],
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'barrio',
                        label: 'Barrio del negocio',
                        disabled: true,
                        type: 'string',
                        col: 6,
                    },
                    {
                        name: 'direccion',
                        label: 'Dirección del negocio',
                        disabled: true,
                        type: 'addressComplement',
                        staticCol: 12,
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia para ubicación del negocio',
                        disabled: true,
                        type: 'string',
                        col: 6,
                    },
                    {
                        name: 'tipo_local',
                        label: 'Tipo de local',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        options: genericOptions.tipo_local,
                    },
                    {
                        name: 'rut',
                        label: 'RUT',
                        disabled: true,
                        type: 'checkbox',
                        col: 1,
                        typeColumn: 3,
                    },
                    {
                        name: 'camara_comercio',
                        label: 'Cámara de comercio',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'registra_compras',
                        label: 'Registra compras',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'registra_ventas',
                        label: 'Registra ventas',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'eps',
                        label: 'EPS',
                        disabled: true,
                        type: 'checkbox',
                        col: 1,
                        typeColumn: 3,
                    },
                    {
                        name: 'sisben',
                        label: 'SISBEN',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'responsable_iva',
                        label: 'Responsable de IVA',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                ],
                defaultValues: {
                    tipo_negocio: 'venta de papa',
                    nombre: 'papaMania',
                    antiguedad: 8,
                    antiguedad_local: 5,
                    descripcion_actividad: 'venta de papa',
                    telefono: '7230000',
                    celular: '3164907501',
                    direccion: 'calle  8norte  13a  45',
                    barrio: 'pruebas',
                    referencia_ubicacion: 'en la esquina cruza',
                    sector_economico: 0,
                    tipo_local: 0,
                    empleados_permanentes: 1,
                    empleados_temporales: 1,
                },
            },
            conyugeClient: {
                permisions: ['conyugeClient:list', 'conyugeClient:edit'],
                fields: [
                    {
                        name: 'Información basica',
                        desc: '',
                        fields: [
                            {
                                name: 'tipo_identificacion',
                                label: 'Tipo identificación',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_de_documento,
                            },
                            {
                                name: 'numero_identificacion',
                                label: 'Número de identificación',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'primer_nombre',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'segundo_nombre',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'primer_apellido',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'segundo_apellido',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'genero',
                                label: 'Género',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.genero,
                            },
                            {
                                name: 'lugar_nacimiento',
                                disabled: true,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'fecha_nacimiento',
                                disabled: true,
                                type: 'date',
                                col: 3,
                            },
                            {
                                name: 'tipo_relacion',
                                label: 'Tipo relación',
                                disabled: true,
                                type: 'hidden',
                                col: 3,
                                value: 0,
                            },
                        ],
                    },
                    {
                        name: 'Información de contacto',
                        desc: '',
                        fields: [
                            {
                                name: 'ciudad_contacto',
                                label: 'Ciudad',
                                disabled: false,
                                type: 'autocomplete-dependency',
                                col: 6,
                                showTable: true,
                                options: [],
                                parentDependency: true,
                                childrenDependency: 'barrio_contacto',
                                url: URL.CIUDADES.value,
                                validation: validationDefault(
                                    ['required'],
                                    'ciudad de contacto'
                                ),
                            },
                            {
                                name: 'barrio_contacto',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                showTable: true,
                                dependency: 'ciudad_contacto',
                                options: [],
                                url: URL.BARRIOS.value,
                                validation: validationDefault(
                                    ['required'],
                                    'barrio de contacto'
                                ),
                            },
                            {
                                name: 'direccion',
                                label: 'Dirección',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.ADDRESS.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.ADDRESS.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.ADDRESS.minLength,
                                        },
                                    ],
                                    'dirección'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                showTable: true,
                            },
                            {
                                name: 'telefono',
                                label: 'Teléfono',
                                disabled: false,
                                type: 'phone',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono'
                                ),
                            },
                            {
                                name: 'celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                            {
                                name: 'correo_electronico',
                                label: 'Correo electrónico',
                                disabled: false,
                                type: 'email',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.EMAIL.regExp,
                                            mesagge:
                                                'El correo electrónico ingresado no es válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.EMAIL.required,
                                        },
                                    ],
                                    'correo electrónico'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'Información del trabajo',
                        desc: '',
                        fields: [
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad (meses)',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono de la empresa',
                                disabled: true,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Ingresos',
                                disabled: true,
                                type: 'price',
                                col: 3,
                            },
                            {
                                name: 'negocio_actividad',
                                label: 'Actividad económica',
                                disabled: true,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                            },
                            {
                                name: 'trabajo_ciudad',
                                label: 'Ciudad de trabajo',
                                disabled: true,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección del trabajo',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                            },
                            {
                                name: 'trabajo_referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                            },
                        ],
                    },
                ],
                defaultValues: {
                    tipo_de_documento: 'CC',
                    numero_identificacion: '123455556',
                    primer_nombre: 'test 1',
                    segundo_nombre: 'test 2',
                    primer_apellido: 'test ape1',
                    segundo_apellido: 'test ape2',
                    genero: 'H',
                    lugar_expedicion_documento: 1205,
                    fecha_expedicion_documento: '2020-08-30',
                    lugar_nacimiento: 1205,
                    fecha_nacimiento: '2020-08-30',
                    telefono_celular: '3105436525',
                    telefono_fijo: '5555555',

                    //info-trabajo
                    empresa: 'pruebas',
                    direccion_trabajo: 'vereda  aaaa',
                    codigo_postal: '76001',
                    descripcion_actividad_economica: 'test information',
                    antiguedad: 1,
                    telefono_empresa: '3215647',
                    ingresos: '200000',
                    actividad_economica: 'Venta de jugos',
                },
            },
            codebtorCredit: {
                permission: ['codebtorCredit:list', 'codebtorCredit:edit'],
                fields: [],
            },
            codebtorInformation: {
                tittle: 'codeudor',
                fields: [
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                    },
                    {
                        name: 'numero_identificacion',
                        label: 'Número identificación',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                    },
                    {
                        name: 'primer_nombre',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'primer_apellido',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'genero',
                        label: 'Género',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        label: 'Lugar expedición documento',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        label: 'Fecha expedición documento',
                        disabled: true,
                        type: 'date',
                        col: 3,
                    },
                    {
                        name: 'lugar_nacimiento',
                        disabled: true,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'fecha_nacimiento',
                        disabled: true,
                        type: 'date',
                        col: 3,
                    },
                    {
                        name: 'tipo_relacion',
                        label: 'Tipo relación',
                        disabled: true,
                        type: 'hidden',
                        col: 3,
                        value: 1,
                    },
                ],
                socioEconomicCodebtor: {
                    fields: [
                        {
                            name: 'naturaleza_persona',
                            label: 'Tipo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_codeudor,
                            isMulti: false,
                        },
                        {
                            name: 'estado_civil',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.estado_civil,
                        },
                        {
                            name: 'estrato',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                        },
                        {
                            name: 'personas_a_cargo',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                        },
                        {
                            name: 'numero_hijos',
                            label: 'Número hijos',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                        },
                        {
                            name: 'escolaridad',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.escolaridad,
                        },
                    ],
                    fieldsConditional: {
                        pI: [
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono del negocio',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono del negocio'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Nombre del negocio',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                            },
                            {
                                name: 'negocio_liquidez',
                                label: 'Liquidez',
                                disabled: false,
                                type: 'price',
                                col: 3,
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad  (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 6,
                            },
                            {
                                name: 'negocio_actividad',
                                label: 'Actividad económica',
                                disabled: false,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                            },
                            {
                                name: 'negocio_descripcion',
                                label: 'Descripción actividad económica',
                                disabled: false,
                                type: 'string',
                                col: 6,
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección del negocio',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                            },
                        ],
                        pE: [
                            // EMPLEADO
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        { type: 'minLength', value: 5 },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_contrato',
                                label: 'Contrato',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                                validation: validationDefault(
                                    ['required'],
                                    'contrato'
                                ),
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Cargo',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'cargo'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'salario'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad empresa (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad empresa'
                                ),
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección empresa',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección empresa'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],
                                    'referencia ubicación'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono empresa',
                                disabled: false,
                                type: 'phone',
                                col: 4,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 4,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                        ],
                        pP: [
                            // PENSIONADO
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_contrato',
                                label: 'Contrato',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                                validation: validationDefault(
                                    ['required'],
                                    'contrato'
                                ),
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Cargo',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'cargo'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'salario'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad empresa (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad empresa'
                                ),
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección empresa',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección empresa'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],
                                    'referencia ubicación'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono empresa',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 4,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                        ],
                        pFR: [
                            // FINCA RAIZ
                            {
                                name: 'trabajo_cargo',
                                label: 'Ocupación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'Ocupación'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                            },
                        ],
                        pFS: [
                            // FIRMA SOLIDARIA
                            {
                                name: 'trabajo_cargo',
                                label: 'Ocupación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'Ocupación'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [{ type: 'minLength', value: 3 }],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                            },
                        ],
                    },
                },
                contactCodebtor: {
                    tittle: 'codeudor',
                    fields: [
                        {
                            name: 'ciudad_contacto',
                            label: 'Ciudad',
                            disabled: true,
                            type: 'autocomplete',
                            col: 6,
                            showTable: true,
                            options: [],
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'barrio',
                            disabled: true,
                            type: 'string',
                            col: 6,
                            showTable: true,
                        },
                        {
                            name: 'direccion',
                            label: 'Dirección',
                            disabled: true,
                            type: 'addressComplement',
                            staticCol: 12,
                            showTable: true,
                        },
                        {
                            name: 'referencia_ubicacion',
                            label: 'Referencia ubicación',
                            disabled: true,
                            type: 'string',
                            col: 6,
                            showTable: true,
                        },
                        {
                            name: 'tipo_vivienda',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_vivienda,
                            defaultValue: [],
                        },
                        {
                            name: 'telefono',
                            label: 'Teléfono',
                            disabled: true,
                            type: 'phone',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.PHONE.regExp,
                                        mesagge:
                                            'El número ingresado no es un número válido',
                                    },
                                ],
                                'teléfono'
                            ),
                        },
                        {
                            name: 'celular',
                            label: 'Celular',
                            disabled: true,
                            type: 'celular',
                            col: 3,
                            showTable: true,
                        },
                        {
                            name: 'correo_electronico',
                            label: 'Correo electrónico',
                            disabled: true,
                            type: 'email',
                            col: 3,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.EMAIL.regExp,
                                        mesagge:
                                            'El correo electrónico ingresado no es válido',
                                    },
                                ],
                                'correo electrónico'
                            ),
                        },
                        {
                            name: 'principal',
                            label: 'Principal',
                            disabled: true,
                            type: 'select',
                            options: genericOptions.direccion_principal,
                            defaultValue: [],
                            col: 3,
                            showTable: true,
                        },
                    ],
                },
                codebtorConyuge: {
                    fields: [
                        {
                            name: 'Información básica',
                            desc: '',
                            fields: [
                                {
                                    name: 'tipo_identificacion',
                                    label: 'Tipo identificación',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.tipo_de_documento,
                                },
                                {
                                    name: 'numero_identificacion',
                                    label: 'Número identificación',
                                    disabled: true,
                                    type: 'integer',
                                    col: 3,
                                },
                                {
                                    name: 'primer_nombre',
                                    disabled: true,
                                    type: 'string',
                                    col: 3,
                                },
                                {
                                    name: 'segundo_nombre',
                                    disabled: true,
                                    type: 'string',
                                    col: 3,
                                },
                                {
                                    name: 'primer_apellido',
                                    disabled: true,
                                    type: 'string',
                                    col: 3,
                                },
                                {
                                    name: 'segundo_apellido',
                                    disabled: true,
                                    type: 'string',
                                    col: 3,
                                },
                                {
                                    name: 'genero',
                                    label: 'Género',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.genero,
                                },
                                {
                                    name: 'lugar_nacimiento',
                                    disabled: true,
                                    type: 'autocomplete',
                                    col: 3,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'fecha_nacimiento',
                                    disabled: true,
                                    type: 'date',
                                    col: 3,
                                },
                                {
                                    name: 'tipo_relacion',
                                    label: 'Tipo relación',
                                    disabled: true,
                                    type: 'hidden',
                                    col: 3,
                                    value: 2,
                                },
                            ],
                        },
                        {
                            name: 'Información de contacto',
                            desc: '',
                            fields: [
                                {
                                    name: 'ciudad_contacto',
                                    label: 'Ciudad',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 6,
                                    showTable: true,
                                    options: [],
                                    parentDependency: true,
                                    childrenDependency: 'barrio_contacto',
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad de contacto'
                                    ),
                                },
                                {
                                    name: 'barrio_contacto',
                                    disabled: false,
                                    type: 'select',
                                    col: 6,
                                    showTable: true,
                                    dependency: 'ciudad_contacto',
                                    options: [],
                                    url: URL.BARRIOS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'barrio de contacto'
                                    ),
                                },
                                {
                                    name: 'direccion',
                                    label: 'Dirección',
                                    disabled: false,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.ADDRESS
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.ADDRESS
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.ADDRESS
                                                    .minLength,
                                            },
                                        ],
                                        'dirección'
                                    ),
                                },
                                {
                                    name: 'referencia_ubicacion',
                                    label: 'Referencia ubicación',
                                    disabled: false,
                                    type: 'string',
                                    col: 6,
                                    showTable: true,
                                },
                                {
                                    name: 'telefono',
                                    label: 'Teléfono',
                                    disabled: false,
                                    type: 'phone',
                                    col: 6,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],
                                        'teléfono'
                                    ),
                                },
                                {
                                    name: 'celular',
                                    label: 'Celular',
                                    disabled: false,
                                    type: 'celular',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.CELL_PHONE
                                                    .regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.CELL_PHONE
                                                    .required,
                                            },
                                        ],
                                        'celular'
                                    ),
                                },
                                {
                                    name: 'correo_electronico',
                                    label: 'Correo electrónico',
                                    disabled: false,
                                    type: 'email',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.EMAIL.regExp,
                                                mesagge:
                                                    'El correo electrónico ingresado no es válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.EMAIL
                                                    .required,
                                            },
                                        ],
                                        'correo electrónico'
                                    ),
                                },
                            ],
                        },
                        {
                            name: 'Información del trabajo',
                            desc: '',
                            fields: [
                                {
                                    name: 'trabajo_nombre',
                                    label: 'Empresa',
                                    disabled: true,
                                    type: 'string',
                                    col: 3,
                                },
                                {
                                    name: 'trabajo_antiguedad',
                                    label: 'Antigüedad (meses)',
                                    disabled: true,
                                    type: 'integer',
                                    col: 3,
                                },
                                {
                                    name: 'trabajo_telefono',
                                    label: 'Teléfono de la empresa',
                                    disabled: true,
                                    type: 'phone',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],
                                        'teléfono de la empresa'
                                    ),
                                },
                                {
                                    name: 'empresa_salario',
                                    label: 'Ingresos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'negocio_actividad',
                                    label: 'Actividad económica',
                                    disabled: true,
                                    type: 'autocomplete',
                                    col: 6,
                                    options: [],
                                    url: URL.ACTIVIDAD_ECONOMICA.value,
                                },
                                {
                                    name: 'trabajo_ciudad',
                                    label: 'Ciudad de trabajo',
                                    disabled: true,
                                    type: 'autocomplete',
                                    col: 6,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'trabajo_direccion',
                                    label: 'Dirección del trabajo',
                                    disabled: true,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                },
                                {
                                    name: 'trabajo_referencia_ubicacion',
                                    label: 'Referencia ubicación',
                                    disabled: false,
                                    type: 'string',
                                    col: 6,
                                },
                            ],
                        },
                    ],
                },
            },
            heritageCodebtor: {
                fields: [
                    {
                        name: 'Presupuesto familiar',
                        desc: '...',
                        fields: [
                            {
                                name: 'ingreso_principal',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'ingreso_conyuge',
                                label: 'Ingresos cónyuge',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'otros_ingresos',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'gastos_familiar',
                                label: 'Gasto familiar',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'obligaciones',
                                label: 'Obligaciones / cuotas',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'excedente',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                        ],
                    },
                    {
                        name: 'Presupuesto empresarial',
                        desc: '...',
                        fields: [
                            {
                                name: 'total_activos',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'total_pasivos',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'total_patrimonio',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                        ],
                    },
                ],
                realState: [
                    {
                        name: 'Bienes raíces',
                        desc: '...',
                        fields: [
                            {
                                name: 'tipo_vivienda',
                                label: 'Tipo de bien raíz',
                                disabled: true,
                                type: 'select',
                                options: genericOptions.tipo_de_bien_raiz,
                                col: 6,
                            },
                            {
                                name: 'direccion_bien_raiz',
                                label: 'Dirección',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                            },
                            {
                                name: 'valor_bien_raiz',
                                label: 'Valor comercial',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                        ],
                    },
                ],
                ownVehicle: [
                    {
                        name: 'Vehículo',
                        desc: '...',
                        fields: [
                            {
                                name: 'marca',
                                disabled: true,
                                type: 'select',
                                col: 6,
                                url: URL.MARCAS.value,
                            },
                            {
                                name: 'placa',
                                disabled: true,
                                type: 'string',
                                col: 6,
                            },
                            {
                                name: 'modelo',
                                disabled: true,
                                type: 'integer',
                                col: 6,
                            },
                            {
                                name: 'valor_vehiculo',
                                label: 'Valor comercial',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                        ],
                    },
                ],
            },
            approvalCertificate: {
                permission: [
                    'list:approvalCertificate',
                    'edit:approvalCertificate',
                ],
                fields: [
                    {
                        name: 'vinculo_agro',
                        label: 'Vínculo agro',
                        disabled: true,
                        type: 'select',
                        options: genericOptions.vinculo_agro,
                        col: 4,
                        validation: validationDefault(
                            ['required'],
                            'Vínculo agro'
                        ),
                    },

                    {
                        name: 'periodo_gracia',
                        disabled: true,
                        type: 'switch',
                        col: 4,
                        typeColumn: 2,
                    },
                    {
                        name: 'meses_periodo',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_de_gracia,
                    },
                    {
                        name: 'excepcion',
                        label: 'Excepción',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        url: URL.TIPO_EXEPCIONES.value,
                    },
                    {
                        name: 'propuesta_inicial',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.propuesta_inicial,
                    },
                    {
                        name: 'codeudores',
                        disabled: true,
                        type: 'select-multiple',
                        col: 8,
                        url: objGenericUrl.personaSolicitud,
                        reduxParams: [
                            'client.numero_identificacion',
                            'credit.id',
                        ],
                    },

                    {
                        name: 'recoge_saldo',
                        disabled: true,
                        type: 'switch',
                        typeColumn: 2,
                        col: 4,
                    },
                    {
                        name: 'tipo_garantia',
                        label: 'Garantía',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        url: URL.TIPO_GARANTIAS.value,
                    },
                ],
                fieldsFng: [
                    {
                        name: 'fng_producto',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        url: URL.FNG_PRODUCTO.value,
                        parentDependency: true,
                        childrenDependency: 'fng_porcentaje',
                    },
                    {
                        name: 'fng_porcentaje',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        dependency: 'fng_producto',
                        url: URL.FNG_PORCENTAJE.value, //?fng_producto=4',
                    },
                    {
                        name: 'fng_calificacion',
                        label: 'Fng calificación',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.calificacion,
                    },
                    {
                        name: 'fng_garantia',
                        label: 'Fng garantía',
                        disabled: true,
                        type: 'integer',
                        col: 4,
                    },
                ],
                fieldsNoApproved: [
                    {
                        name: 'causal',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.causal_no_aprobado,
                    },
                ],
            },
            filterDataTable: {
                permisions: ['filterDataTable'],
                fields: [
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'ejecutivo',
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                    },
                    {
                        name: 'ejecutivos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 3,
                        //options: [],
                        dependency: 'oficinas',
                        url: URL.EJECUTIVOS.value,
                        notSearchGlobals: true,
                    },
                    {
                        name: 'created_at__gte',
                        label: 'Fecha inicial',
                        disabled: false,
                        type: 'date',
                        col: 3,
                    },
                    {
                        name: 'created_at__lte',
                        label: 'Fecha final',
                        disabled: false,
                        type: 'date',
                        col: 3,
                    },
                ],
            },
            reportsGeneral: {
                fields: [
                    {
                        name: 'tipo_reporte',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: '/globals/gestor_reportes/?rol=31',
                        // defaultValue: {
                        //     value: '1',
                        //     label: 'GESTIÓN COMITE',
                        // },
                        validation: {
                            required: {
                                value: true,
                                message: 'El tipo reporte es obligatorio',
                            },
                        },
                        notSearchGlobals: true,
                    },
                    {
                        name: 'subproductos',
                        label: 'Subproductos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: URL.SUBPRODUCTO.value,
                    },
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        options: [],
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                    },
                    {
                        name: 'fecha_desde',
                        label: 'Fecha desde',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha desde es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'fecha_hasta',
                        label: 'Fecha hasta',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha hasta es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'year',
                        label: 'Año',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.anios_report,
                        defaultValue: defaultYearReport(),
                        validation: {
                            required: {
                                value: true,
                                message: 'El Año es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'month',
                        label: 'Mes',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_report,
                        defaultValue: defaultMonthReport(),
                        validation: {
                            required: {
                                value: true,
                                message: 'El Mes es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'regionales',
                        label: 'Regionales',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: URL.REGIONALES.value,
                    },
                    {
                        name: 'producto',
                        label: 'Producto',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: URL.PRODUCTOS.value,
                        validation: {
                            required: {
                                value: true,
                                message: 'El campo producto es obligatorio',
                            },
                        },
                    },
                ],
            },
            reportTeamPerformance: {
                fields: [
                    {
                        name: 'groups',
                        label: 'Rol',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        parentDependency: true,
                        childrenDependency: 'user',
                        options: [
                            { value: 2, label: 'MESA DE AYUDA' },
                            { value: 3, label: 'EJECUTIVO' },
                            { value: 4, label: 'MESA DE APROBACION' },
                            { value: 5, label: 'APROBADOR' },
                        ],
                        defaultValue: { value: 4, label: 'MESA DE APROBACION' },
                    },
                    {
                        name: 'user',
                        label: 'Usuario',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        dependency: 'groups',
                        options: [],
                        url: '/globals/users/?is_active=true',
                        optionsExtra: {
                            value: 777889900,
                            label: 'CONSOLIDADO',
                        },
                        defaultValue: {
                            value: 777889900,
                            label: 'CONSOLIDADO',
                        },
                    },
                    {
                        name: 'type_group',
                        label: 'Tipo',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: [
                            { value: 0, label: 'AÑO - MES' },
                            { value: 1, label: 'MES - DIA' },
                        ],
                        defaultValue: { value: 0, label: 'AÑO - MES' },
                    },
                    {
                        name: 'year',
                        label: 'Año',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.anios_report,
                        defaultValue: defaultYearReport(),
                    },
                    {
                        name: 'month',
                        label: 'Mes',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_report,
                    },
                ],
            },
            reportsAnexos: {
                fields: [
                    {
                        name: 'tipo_Anexo',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.tipo_reporte_anexos,
                        validation: {
                            required: {
                                value: true,
                                message: 'El tipo de reporte es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'anexo5',
                        label: 'Documentos',
                        disabled: false,
                        type: 'file',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'El archivo del anexo es obligatorio',
                            },
                        },
                    },
                    // {
                    //     name: 'fecha_cartera',
                    //     label: 'Fecha reporte',
                    //     disabled: false,
                    //     type: 'date',
                    //     col: 3,
                    //     validation: {
                    //         required: {
                    //             value: true,
                    //             message:
                    //                 'La fecha del concesionario es obligatorio',
                    //         },
                    //     },
                    // },
                ],
            },
            reportMonthEnd: {
                fields: [
                    {
                        name: 'tipo_reporte',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: [
                            { value: '0', label: 'REPORTE EDADES CLIENTES' },
                            {
                                value: '1',
                                label: 'REPORTE CIIU HISTORICO CREDITOS GYG',
                            },
                            {
                                value: '3',
                                label: 'RESULTADO BONIFICACIONES',
                            },
                        ],
                        validation: validationDefault(
                            ['required'],
                            'tipo reporte'
                        ),
                    },
                    {
                        name: 'fecha_cierre_mes',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: validationDefault(
                            ['required'],
                            'fecha cierre mes'
                        ),
                    },
                    {
                        name: 'year',
                        label: 'Año',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.anios_report,
                        defaultValue: defaultYearReport(),
                        validation: {
                            required: {
                                value: true,
                                message: 'El Año es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'month',
                        label: 'Mes',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_report,
                        defaultValue: defaultMonthReport(),
                        validation: {
                            required: {
                                value: true,
                                message: 'El Mes es obligatorio',
                            },
                        },
                    },
                ],
            },
            reportCir: {
                fields: [
                    {
                        name: 'archivo_fng_cir',
                        label: 'Documento',
                        disabled: false,
                        type: 'file',
                        staticCol: 12,
                        validation: {
                            required: {
                                value: true,
                                message: 'El archivo del CIR es obligatorio',
                            },
                        },
                    },
                ],
            },
            reportsGuarantees: {
                fields: [
                    {
                        name: 'tipo_reporte',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: [...genericOptions.tipo_reporte_garantia],
                        validation: {
                            required: {
                                value: true,
                                message:
                                    'El nombre del tipo reporte es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'clase',
                        label: 'Clase',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.case_tipo_reporte_garantia,
                        validation: {
                            required: {
                                value: true,
                                message: 'La clase es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'medio_generacion_reporte',
                        label: 'Medio generación reporte',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: [
                            { value: 'fecha', label: 'POR FECHA' },
                            { value: 'archivo', label: 'POR ARCHIVO' },
                        ],
                        validation: {
                            required: {
                                value: true,
                                message:
                                    'El nombre del medio de generación del reporte es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'year',
                        label: 'Año',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.anios_report,
                        defaultValue: defaultYearReport(),
                        validation: {
                            required: {
                                value: true,
                                message: 'El campo de año es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'month',
                        label: 'Mes',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_report,
                        defaultValue: defaultMonthReport(),
                        validation: {
                            required: {
                                value: true,
                                message: 'El campo de mes es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'archivo',
                        label: 'Documento',
                        disabled: false,
                        type: 'file',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'El campo de documento es obligatorio',
                            },
                        },
                    },
                ],
            },
            filterDataTableWarranty: {
                permisions: ['filterDataTableWarranty'],
                fields: [
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 6,
                        options: [],
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                        notSearchGlobals: true,
                    },
                    {
                        name: 'productos',
                        label: 'Productos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 6,
                        //options: [],
                        url: '/globals/productos/?id=4,6,1',
                        notSearchGlobals: true,
                    },
                ],
            },
            documentsWarranty: {
                permisions: [
                    'documentsWarranty:list',
                    'documentsWarranty:edit',
                ],
                fields: [
                    {
                        name: 'tipo_documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/globals/gmv_tipo_documentos/?roles=31&is_active=true&tramite_voluntario={0}&estado={1}',
                        reduxParams: [
                            'warranty.tramite_voluntario_String',
                            'warranty.estado.value',
                        ],
                        options: [],
                        showTable: true,
                        notSearchGlobals: true,
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                    },
                ],
            },
            observationWarranty: {
                permisions: ['observationWarranty:list'],
                fields: [
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        rows: 1,
                        typeColumn: 2,
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            InformationWarrantyVehicle: {
                permisions: [
                    'InformationWarrantyVehicle:list',
                    'InformationWarrantyVehicle:edit',
                ],
                fieldsUbicacion: [
                    {
                        name: 'ciudad_ubicacion',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_ubicacion',
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'barrio_ubicacion',
                        label: 'Barrio ubicación',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_ubicacion',
                        trueDependency: 'ciudad',
                        notSearchGlobals: true,
                        url: URL.BARRIOS.value,
                    },
                    {
                        name: 'direccion_ubicacion',
                        label: 'Dirección',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                ],
                fieldsEstado: [
                    {
                        name: 'peritaje',
                        label: 'Peritaje',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        options: [
                            { value: 'true', label: 'SI' },
                            { value: 'false', label: 'NO' },
                        ],
                    },
                    {
                        name: 'kilometraje',
                        label: 'Kilometraje',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'gps',
                        label: 'GPS',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        options: [
                            { value: 'true', label: 'SI' },
                            { value: 'false', label: 'NO' },
                        ],
                    },
                    {
                        name: 'tipo_propietarios_vehiculo',
                        label: 'Propietario vehículo',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        url: `/globals/gmv_tipo_propietarios_vehiculos/?is_active=true`,
                    },
                    {
                        name: 'valor_fasecolda_vehiculo',
                        label: 'Valor fasecolda',
                        disabled: false,
                        type: 'price',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'valor_peritaje_vehiculo',
                        label: 'Valor peritaje',
                        disabled: false,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Valor peritaje'
                        ),
                    },
                ],
            },
            ContactsWarranty: {
                permisions: [
                    'ContactsWarranty:list',
                    'ContactsWarranty:edit',
                    'ContactsWarranty:deleteButton',
                ],
                fields: [
                    {
                        name: 'nombre',
                        label: 'Nombre',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(['required'], 'nombre'),
                    },
                    {
                        name: 'celular',
                        label: 'Número telefónico',
                        disabled: false,
                        showTable: true,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                    {
                        name: 'tipo',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        options: [
                            { value: 'ENCARGADO', label: 'ENCARGADO' },
                            { value: 'OTRO', label: 'OTRO' },
                        ],
                        validation: validationDefault(['required'], 'tipo'),
                    },
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                ],
            },
            InformationWarranty: {
                permisions: [
                    'InformationWarranty:list',
                    'InformationWarranty:edit',
                ],
                fields: [
                    {
                        name: 'solicitud.id',
                        label: 'Solicitud de crédito',
                        disabled: true,
                        type: 'string',
                        col: 4,
                        showTable: true,
                    },
                    {
                        name: 'solicitud.oficina',
                        label: 'Oficina',
                        disabled: true,
                        showTable: true,
                        type: 'select',
                        options: [],
                        col: 4,
                    },
                    {
                        name: 'solicitud.codigo_gyg',
                        label: 'Num crédito',
                        disabled: true,
                        type: 'string',
                        col: 4,
                        showTable: true,
                    },
                    {
                        name: 'solicitud.dias_mora',
                        label: 'Días mora',
                        disabled: true,
                        type: 'string',
                        col: 4,
                        showTable: true,
                    },
                    {
                        name: 'solicitud.saldo_prestamo',
                        label: 'Saldo',
                        disabled: true,
                        type: 'price',
                        col: 4,
                        showTable: true,
                    },
                ],
            },
            FinancialEvaluationWarranty: {
                permisions: [
                    'FinancialEvaluationWarranty:list',
                    'FinancialEvaluationWarranty:edit',
                ],
                fields: [
                    {
                        name: 'valor_acuerdo_venta_vehiculo',
                        label: 'Valor acuerdo venta',
                        disabled: false,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Valor acuerdo'
                        ),
                    },
                    {
                        name: 'gastos_vehiculo',
                        label: 'Gastos vehículo',
                        disabled: true,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Gastos vehiculo'
                        ),
                    },
                    {
                        name: 'valor_venta_vehiculo',
                        label: 'Valor venta vehículo',
                        disabled: true,
                        type: 'price',
                        col: 6,
                        showTable: true,
                    },
                ],
            },
            filterDataTableFinancialSolutions: {
                permisions: ['filterDataTableFinancialSolutions'],
                fields: [
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        options: [],
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                    },
                    {
                        name: 'subproductos',
                        label: 'Subproductos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        //options: [],
                        url: '/globals/subproducto/',
                        notSearchGlobals: true,
                    },
                    {
                        name: 'tipo_solucion_financiera',
                        label: 'Tipo',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: '/globals/sf_tipo_soluciones_financieras/ ',
                        notSearchGlobals: true,
                    },
                ],
            },
            BillsWarranty: {
                permisions: ['BillsWarranty:list'],
                fields: [
                    {
                        name: 'tipo_gasto',
                        label: 'Tipo gasto',
                        disabled: true,
                        type: 'select',
                        col: 12,
                        staticCol: 12,
                        showTable: true,
                        url: '/globals/tipo_gastos_gmv/',
                        validation: validationDefault(
                            ['required'],
                            'Tipo gasto'
                        ),
                    },

                    {
                        name: 'valor',
                        label: 'Valor',
                        disabled: true,
                        type: 'price',
                        col: 12,
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefault(['required'], 'Valor'),
                    },
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: true,
                        type: 'string',
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                    },
                    {
                        name: 'documento',
                        label: 'Factura',
                        disabled: true,
                        type: 'file',
                        col: 12,
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefault(['required'], 'Factura'),
                    },
                ],
            },
        },
    },
};

export default Rules;
